import React from "react";
import { useTranslation } from "react-i18next";

const Recognitions = () => {

  const { t } = useTranslation("home");

  const recognitions = [
    {
      name: "Kerala Startup Mission",
      image: "/ksum.svg",
    },
    {
      name: "Startup India",
      image: "/startup-india.webp",
    },
    {
      name: "MSME",
      image: "/msme.png",
    },
  ];

  return (
    <div className="my-10 py-10 px-20 flex flex-col gap-12 justify-center items-center bg-blue-50">
      <p className="text-[3.25rem] font-medium leading-[3.9rem] sm-max:text-[2.25rem] sm-max:leading-[2.875rem] sm-max:text-center">
        {t("recognitions.title")}
      </p>
      <div className="flex md-max:flex-col gap-6 justify-center items-center">
        {recognitions.map((item) => (
          <div
            key={item.name}
            className="w-[300px] flex justify-center items-center"
          >
            <img
              src={item.image}
              alt={item.name}
              className="h-[150px] w-full object-contain"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Recognitions;
